export const areArraysEqual = <T>(
  a: T[],
  b: T[],
  compareFn: (x: T, y: T) => number = (x, y) => (x > y ? 1 : x < y ? -1 : 0)
): boolean => {
  if (a.length !== b.length) return false;

  const sortedA = [...a].sort(compareFn);
  const sortedB = [...b].sort(compareFn);

  return sortedA.every((val, i) => val === sortedB[i]);
};

  